import { FC } from 'react';
import styles from './ProviderMarks.module.css';

const PROVIDER_MARKS: Record<string, { monogram: string; color: string }> = {
  Equifax: { monogram: 'EQ', color: '#b71c1c' },
  Experian: { monogram: 'EX', color: '#1565c0' },
  Truework: { monogram: 'TW', color: '#2e7d32' },
  Truv: { monogram: 'TV', color: '#6a1b9a' },
  Argyle: { monogram: 'AR', color: '#e65100' },
  Plaid: { monogram: 'PL', color: '#00695c' },
  Halcyon: { monogram: 'HC', color: '#37474f' },
};

export const ProviderMark: FC<{ vendor: string }> = ({ vendor }) => {
  const known = PROVIDER_MARKS[vendor];
  const monogram = known?.monogram ?? vendor.substring(0, 2).toUpperCase();
  const color = known?.color ?? '#78909c';
  return (
    <span
      className={styles.mark}
      style={{ backgroundColor: color }}
      title={vendor}
    >
      {monogram}
    </span>
  );
};
